export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            highlightable:false,
            attributes:{
                "data-slg-type":"C-RADIO-GROUP"
            },
            classes:['radio-group'],
            options:[],
            question_id:null,
            inline:true
        },
        
        renderAllOptions(options) {
            let component = this;
            options.forEach( (op) => {
                component.renderOption(op);
            });
        },
        renderOption(option){
            let component = this;
            let find = component.components().models.find(comp => {
                return option.key == comp.getId();
            });
            if(find){
                component.updateOption(option,find);
            }else{
                component.addOption(option);
            }
        },
        addOption: function (option){
            let component = this;
            // let question_id = (component.get("question_id")) ? component.get("question_id"):"" ;
            let parent_component = component.parent();
            let parent_attributes = parent_component.getAttributes();
            let question_id = parent_attributes['data-slg-question-id'];

            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let component_option = {
                tagName:'div',
                droppable: false,
                draggable:false,
                // highlightable:false,
                // badgable:false,
                // hoverable:false,
                removable:false,
                copyable:false,
                attributes:{
                    id:option.key,
                },
                classes:['form-check'],
                components:[
                    {
                        type:'radio',
                        droppable: false,
                        draggable:false,
                        removable:false,
                        copyable:false,
                        toolbar:[],    
                        attributes:{
                            type:'radio',
                            id:`op${option.value}`,
                            value:option.value,
                            name:`answers[${question_id}]`,
                            "data-slg-coregistros":coregistros,
                            required:true
                        },
                        classes:['form-check-input']
                    },
                    {
                        type:"label",
                        droppable: false,
                        draggable:false,
                        removable:false,
                        copyable:false,
                        toolbar:[],  
                        attributes:{
                            for:`op${option.value}`
                        },
                        classes:['form-check-label'],
                        content:option.label
                    }
                ]
            }
            component.append(component_option);
        },
        updateOption(option, component){
            // Update input
            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let input = component.findType('radio')[0];
            let attributes = input.getAttributes();
            let parentComponent = this.parent();
            let parentAttributes = parentComponent.getAttributes();
            let questionId = parentAttributes['data-slg-question-id'];
            console.log("questionId:", questionId);
            input.addAttributes({
                ...attributes,
                value:option.value,
                "data-slg-coregistros":coregistros,
                name:`answers[${questionId}]`,
            });
            // Update label
            // let label = component.components().at(1);
            let label = component.findType('label')[0];
            label.components(option.label);
            
        },
        deleteOption: function (option){
            let component = this;
            let find = component.components().models.find(comp => {
              return option.key == comp.getId();
            })
            find.remove();
        },
        cleanOptions: function(options){
            let component = this;
            let components = component.components();
            let listToDelete = [];
            for (let i = 0; i < components.length; i++) {
                const comp = components.at(i);
                let find = options.find(op => op.key == comp.getId());
                if(!find)
                    listToDelete.push(comp);
            }
            listToDelete.forEach(item => { 
                item.remove();
            });
        } 
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-RADIO-GROUP")
                return { type:'C-RADIO-GROUP' }
        }
    });

    var view = VIEW.extend({
        init: function () {
          let model = this.model;
        },

        onRender() {
            /* this.renderOptions(); */
        },

        renderAllOptions: function (options) {
            options.forEach( (op) => {
                this.renderOption(op);
            });
        },
        renderOption: function(option){
            let find = this.model.components().models.find(comp => {
                return option.key == comp.getId();
            });
            console.log("Find",find);
            if(find){
                this.updateOption(option,find);
            }else{
                this.addOption(option);
            }
        },
        addOption: function (option){
            // let question_id = (this.model.get("question_id")) ? this.model.get("question_id"):"" ;
            let parent_component = component.parent();
            let parent_attributes = parent_component.getAttributes();
            let question_id = parent_attributes['data-slg-question-id'];

            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let component_option = {
                tagName:'div',
                droppable: false, 
                attributes:{
                    id:option.key,
                    class:'form-check'
                },
                components:[
                    {
                        type:'radio',
                        droppable: false, 
                        attributes:{
                            type:'radio',
                            value:option.value,
                            id:`op${option.value}`,
                            name:`answers[${question_id}]`,
                            class:"form-check-input",
                            "data-slg-coregistros":coregistros,
                            required:false
                        }
                    },
                    {
                        type:"label",
                        editable:true,
                        droppable: false, 
                        attributes:{
                            class:'form-check-label',
                            for:`op${option.value}`
                        },
                        /* content:option.label */
                        components:[
                            {
                                type:"text",
                                droppable: false,
                                content:option.label
                            }
                        ]
                    }
                ]
            }
            this.model.append(component_option); 
        },
        updateOption: function(option,component){
            // Update input
            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let attributes = component.components().at(0).getAttributes();
            let parentComponent = component.parent();
            let parentAttributes = parentComponent.getAttributes();
            let questionId = parentAttributes['data-slg-question-id'];
            console.log("questionId",questionId);
            component.components().at(0).setAttributes({
                ...attributes,
                value:option.value,
                "data-slg-coregistros":coregistros,
                name:`answers[${questionId}]`,
            });
            // Update label
            let label = component.components().at(1);
            /* label.set('content',option.label); */
            let text = label.components().at(0);
            if(text.components().length > 0){
                text.components().at(0).set('content',"");
            }
            /* text.empty(); */
            text.set("content",option.label);
            /* let textnode_view = textnode.getView();
            textnode_view.render(); */
            
        },
        deleteOption: function (option){
            let find = this.model.components().models.find(comp => {
              
              return option.key == comp.getId();
            })
            find.remove();
        },
        cleanOptions: function(options){
            let components = this.model.components();
            let listToDelete = [];
            for (let i = 0; i < components.length; i++) {
                const comp = components.at(i);
                let find = options.find(op => op.key == comp.getId());
                if(!find)
                    listToDelete.push(comp);
            }
            listToDelete.forEach(item => { 
                item.remove();
            });
        } 
    });

    DOMC.addType('C-RADIO-GROUP', {
      model:model,
      view:view,
    });
};
  